<template>
    <div class="content">
        <div class="header">
            <div class="title" @click="showTree">{{ department_name }}({{ total }}人)</div>
            <div class="btn_left">
                <el-button v-if="power_safe" @click="openDialogTree('superiors')" type="text">变更上级
                </el-button>
            </div>
            <div class="btn_box">
                <el-button v-if="power_safe" type="text" @click="openEdit(selectTreeNode)">修改名称</el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button v-if="power_safe" type="text" @click="openAdd(selectTreeNode)">添加子部门</el-button>
                <!-- <el-divider direction="vertical"></el-divider>
                <el-button type="text">设置负责人</el-button> -->
            </div>
        </div>
        <div class="top_btn_box">
            <div>
                <el-button size="mini" v-if="power_safe" @click="com_add">添加成员</el-button>
                <!-- <el-button size="mini">批量导入/导出</el-button>
                <el-button size="mini">批量设置成员信息</el-button> -->
                <el-button size="mini" v-if="power_safe" type="danger" @click="delMore">删除</el-button>
            </div>
            <!-- 分页
                        <div class="page_box">
                            <div @click="change_page(-1)" class="page_icon last_page">
                                <i class="el-icon-arrow-left"></i>
                            </div>
                            <div class="page_text">
                                {{currentPage}}/ {{page_num}}
                            </div>
                            <div @click="change_page(1)" class="page_icon next_page">
                                <i class="el-icon-arrow-right"></i>
                            </div>
                        </div>-->
        </div>

        <div class="table_box staff_table_box">
            <el-table :data="tableData"
                      stripe
                      @selection-change="handleSelectionChange"
                      @cell-click="click_name"
                      width="100%"
                      ref="table"
                      :height="tableHeight">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="姓名"
                                 prop="name"
                ></el-table-column>
                <el-table-column v-for="(item, index) in columnData"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :width="item.width"
                                 :formatter="item.formatter"
                                 :fixed="item.fixed"
                                 show-overflow-tooltip
                                 :key="index">
                    <template slot-scope="scope">
                        <div v-if="scope.column.property === 'name'"
                             :class="scope.row.is_quit == 2 ? 'is_level_job' : ''">
                            {{ scope.row[scope.column.property] }}
                        </div>
                        <div v-text="showTableLabel(scope.row[scope.column.property], scope.column.property)" v-else>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="300">
                    <template slot-scope="scope">
                        <el-button type="text"
                                   v-if="scope.row.is_quit == 1 && power_safe"
                                   @click="editRow(scope.row, 'user')">
                            编辑人员
                        </el-button>
                        <el-button type="text"
                        v-if="power_safe"
                                   @click="editRow(scope.row, 'work')">
                            编辑岗位
                        </el-button>
                        <el-button type="text"
                        v-if="power_safe"
                                   @click="editRow(scope.row, 'change')">
                            更换人员
                        </el-button>

                        <el-button type="text"
                                   class="table_del_btn"
                                   v-if="scope.row.is_quit == 1 && power_safe"
                                   @click="leaveOffice(scope.row)">
                            离职
                        </el-button>

                        <el-popover placement="bottom"
                                    width="200"
                                    trigger="click">
                            <div>
                                <el-button type="text"
                                           class="table_del_btn"
                                           @click="delRowUser(scope.row)">
                                    <i class="el-icon-delete"></i>
                                    删除人员
                                </el-button>
                                <el-button type="text"
                                           class="table_del_btn"
                                           @click="delRow(scope.row)">
                                    <i class="el-icon-delete"></i>
                                    删除岗位
                                </el-button>
                            </div>

                            <el-button slot="reference"
                                       type="text"
                                       v-if="power_safe"
                                       class="table_del_btn">
                                <i style="padding-left: 5px" class="el-icon-delete"></i>
                                删除
                            </el-button>
                        </el-popover>

                        <el-button type="text"
                                   class="table_del_btn"
                                   v-if="power_safe"
                                   @click="openDialogTree(scope.row)">
                            变更部门
                        </el-button>
                        <el-button type="text"
                        v-if="power_wx"
                                   @click="changeWXPower(scope.row)">
                            权限限制
                        </el-button>
                        <el-button type="text"
                                   v-if="scope.row.is_lock == 2"
                                   class="table_btn"
                                   @click="openLockedDialog(scope.row, 'is_lock')">
                            解除锁定
                        </el-button>
                        <el-button type="text"
                                   class="table_del_btn"
                                   @click="refreshCheckCode(scope.row)">
                            重置核验码
                        </el-button>
                        <!-- <el-button type="text"
                                   v-if="scope.row.patient_is_lock == 2"
                                   class="table_btn"
                                   @click="openLockedDialog(scope.row, 'patient_is_lock')">
                            解除附件锁定
                        </el-button> -->
                    </template>
                </el-table-column>
            </el-table>
        </div>


        <el-dialog :title="change_tree_title"
                   width="450px"
                   :modal="false"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :show-close="false"
                   :visible.sync="change_tree">
            <el-form :model="treeForm" label-width="120px" ref="treeForm">
                <el-form-item label="部门名称" prop="name">
                    <el-cascader v-model="treeForm.department_id" :options="treeDataAll" :props="treeOptions" filterable
                                 :show-all-levels="false" clearable></el-cascader>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="change_tree = false">取 消</el-button>
                <el-button type="primary" @click="submitChangeTree">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="locked_dialog_title"
                   width="450px"
                   :modal="false"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :visible.sync="locked_dialog">
            <div class="msg__">
                <span>将解除</span>
                <span class="table_del_btn" style="padding-left: 5px">{{locked_row.name}}</span>
                <span>核验码锁定</span>
            </div>
            <div class="msg__" v-if="locked_type === 'is_lock'">
                <el-checkbox v-model="locked_is_refresh">
                    <span class="msg_c">同时重置核验码</span>
                </el-checkbox>
            </div>


            <span slot="footer" class="dialog-footer">
                <el-button @click="locked_dialog = false">取 消</el-button>
                <el-button type="primary" @click="clearLocked">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :title="wx_dialog_title"
                   width="450px"
                   :modal="false"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :visible.sync="wx_dialog">
            <el-form :model="wx_form" :rules="wxRules" label-width="80px">
                <el-form-item label="权限：" prop="module_permission">
                    <el-checkbox-group v-model="wx_form.module_permission">
                        <el-checkbox v-for="(item,index) in wxPowerList"
                            :ky="index"
                            :label="item.value"
                        >{{ item.name }}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>


            <span slot="footer" class="dialog-footer">
                <el-button @click="wx_dialog = false">取 消</el-button>
                <el-button @click="wxClear" type="danger">清除限制</el-button>
                <el-button type="primary" @click="wxSubmit">保存权限</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState, mapMutations} from 'vuex'
    import {clone} from "@/global/utils";

    export default {
        name: "tableView",
        components: {},
        data() {
            return {
                searchNode: {},

                department_name: '',

                tableHeight: null,
                tableData: [],
                columnData: [
                    // {label: '姓名', prop: 'name'},
                    {label: '工号', prop: 'job_number'},
                    {label: '岗位', prop: 'job', width: 220},
                    {label: '部门', prop: 'section'},
                    {label: '职位', prop: 'is_manager'},
                    {label: '手机', prop: 'phone', width: 110},
                    {label: '微信注册', prop: 'first_bind_time'},
                ],

                ifList: [
                    {name: '代表', value: 1},
                    {name: '经理', value: 2},
                    {name: 'RPM', value: 3},
                    {name: 'RPMHead', value: 4},
                ],

                total: 0,
                currentPage: 1,
                pageSize: 10,

                select_table: [],

                change_tree: false,
                change_tree_title: '变更上级',
                treeForm: {
                    department_id: '',
                },
                treeData: [],
                treeOptions: {
                    checkStrictly: true,
                    emitPath: false,
                    expandTrigger: 'hover',
                    value: 'department_id',
                    label: 'name',
                    children: 'children'
                },


                locked_dialog: false,
                locked_dialog_title: '解除锁定',
                locked_row: {},
                locked_is_refresh: false,
                locked_type: '',


                wx_dialog: false,
                wx_row: {},
                wx_dialog_title: '权限限制',
                wx_form: {
                    module_permission: [],
                },
                wxRules: {
                    module_permission: [
                        {required: true, message: '请选择权限', trigger: 'change'}
                    ]
                },
                wxPowerList: [
                    {name: '新增拜访', value: 'add'},
                    {name: '日常随访', value: 'list'},
                    {name: '数据分析', value: 'echart'},
                    {name: '使用说明', value: 'use'},
                ]
            }
        },
        computed: {
            ...mapState("manageData", {
                selectTreeNode: 'selectTreeNode',
                clickNode: 'clickNode',
                searchStaffNode: 'searchStaffNode',
                treeDataAll: 'treeDataAll'
            }),
            ...mapState('comInformationData', {
                authority: 'authority',
            }),
            page_num() {
                return Math.ceil(this.total / this.pageSize)
            },
            power_safe() {
                return this.authority.indexOf('staff-staff-safe') > -1
            },
            power_wx() {
                return this.authority.indexOf('staff-staff-wx') > -1
            },
        },
        watch: {
            clickNode() {
                this.department_name = this.selectTreeNode.name;
                this.getTableData()
            },

        },
        mounted() {
            if (this.selectTreeNode && this.selectTreeNode.department_id) {
                this.department_name = this.selectTreeNode.name;
                this.getTableData(this.currentPage)
            }
            this.$nextTick(() => {
                this.getTableHeight()
            })
        },
        methods: {
            ...mapMutations('manageData', {
                setStaffData: 'setStaffData',
                setShowTree: 'setShowTree',
                setTreeDataAll: 'setTreeDataAll',
                setSearchStaff: 'setSearchStaff',
            }),
            changeWXPower(row) {
                this.wx_row = row;
                this.wx_form.module_permission = this.wx_row.module_permission ? this.wx_row.module_permission.split(',') : [];
                this.wx_dialog = true;

            },
            wxSubmit() {
                let params = {
                    user_id: this.wx_row.user_id,
                    module_permission: this.wx_form.module_permission.join(',')
                };
                this.httpPost('/user/module_permission/save', params).then(res => {
                    this.$message.success('保存成功！');
                    this.getTableData();
                    this.wx_dialog = false;
                })
            },
            wxClear() {
                
                let params = {
                    user_id: this.wx_row.user_id,
                };
                this.httpGet('/user/module_permission/clear', params).then(res => {
                    this.$message.success('清除限制成功！');
                    this.getTableData();
                    this.wx_dialog = false;
                })
            },

            showTableLabel(cellValue, prop) {
                if (prop === 'is_manager') {
                    let text = '';
                    this.ifList.map(v => {
                        if (v.value == cellValue) {
                            text = v.name
                        }
                    })
                    return text
                }
                if (prop === 'first_bind_time') {
                    let text = cellValue ? '已注册' : '未注册';
                    return text
                }
                return cellValue
            },

            openLockedDialog(row, type) {
                this.locked_row = row;
                this.locked_dialog = true;
                this.locked_is_refresh = false;

                this.locked_type = type
                this.locked_dailog_title = type === 'patient_is_lock' ? '解除附件锁定' : '解除用户锁定';
            },
            clearLocked() {
                let params = {
                    user_id: this.locked_row.user_id,
                    is_reset: this.locked_is_refresh?2:1,
                };
                if(this.locked_type === 'patient_is_lock') {
                    params.is_patient = 1
                }
                this.httpGet('/user/rep/unlock', params).then(res => {
                    this.$message.success(`${this.locked_dailog_title}成功！`);
                    this.getTableData();
                    this.locked_dialog = false;
                })
            },
            refreshCheckCode(row) {
                let params = {
                    user_id: row.user_id
                };
                this.httpGet('/user/validate_password/reset', params).then(res => {
                    this.$message.success('核验码重置成功！');
                })
            },
            showTree() {
                this.setShowTree(true);
                this.$emit('changeShowTree');
            },

            getTree() {
                this.httpGet('/department').then(res => {
                    this.careTree(res.data)
                })
            },
            careTree(list) {
                const check = (staff) => {
                    staff.forEach(v => {
                        if (v.children && v.children.length > 0) {
                            check(v.children)
                        } else {
                            v.children = null
                        }
                    })
                };
                check(list);
                setTimeout(() => {
                    this.setTreeDataAll(clone(list));
                    let data = {
                        ...this.selectTreeNode,
                        parent_id: this.treeForm.department_id
                    };
                    this.$emit('changeNode', data)
                }, 10)
            },
            openDialogTree(val) {
                if (val === 'superiors') {
                    this.change_tree_title = '变更上级';
                    this.treeForm.department_id = clone(this.selectTreeNode.parent_id);
                    this.treeForm.self_department_id = clone(this.selectTreeNode.department_id);
                    console.log(this.selectTreeNode, '267');
                } else {
                    this.change_tree_title = '变更部门';
                    console.log(val, '276');
                    this.treeForm.department_id = clone(val.department_id);
                    this.treeForm.job = clone(val.job);
                    this.treeForm.self_department_id = clone(val.department_id);
                }
                this.change_tree = true;
            },
            submitChangeTree() {
                console.log(this.treeForm, '276');
                let url = '/department/move'; // 更改上级
                let params = {};
                if (this.change_tree_title === '变更部门') {
                    url = '/user/rep_job/move';
                    params = {
                        department_id: this.treeForm.self_department_id,
                        job: this.treeForm.job,
                        new_department_id: this.treeForm.department_id
                    }
                } else {
                    params = {
                        department_id: this.treeForm.self_department_id,
                        parent_id: this.treeForm.department_id
                    }
                }
                console.log(params, url, '--------');
                this.httpPost(url, params).then(res => {
                    if (this.change_tree_title === '变更部门') {
                        this.getTableData()
                    } else {
                        this.getTree();
                    }
                    this.$message.success('变更成功');
                    this.change_tree = false;
                })
            },

            openAdd(node) {
                // this.$emit('openAdd', node)
                this.$parent.openAdd(node)
            },
            openEdit(node) {
                // this.$emit('openEdit', node)
                this.$parent.openEdit(node)
            },

            change_page(val) {
                let page = this.currentPage + val;
                return;
                if (page > 0 && page <= this.page_num) {
                    this.getTableData(page);
                }
            },
            getTableData(v = 1) {
                console.log(v, 'getTable');
                let params = {
                    department_id: this.selectTreeNode.department_id,
                    // page: v,
                    // page_size: this.pageSize
                };
                this.httpGet('/user/rep_job', params).then(res => {
                    this.tableData = res.data;
                    this.total = res.data.length;
                    this.select_table = []; // 每次请求列表都把多选清空
                    // this.$nextTick(() => {
                    //     // this.currentPage = v
                    //     this.$refs.table.doLayout();
                    // })
                })
            },

            click_name(row, column, cell, event) {
                // console.log(row, column, cell, event, '337');
                if (column.property === 'name') {
                    this.setSearchStaff(row);
                    this.$emit('changeTopTab', 'lookView');
                }
            },

            handleSelectionChange(val) {
                console.log(val);
                this.select_table = val
            },
            delMore() {
                this.$message.warning('正在开发中');
                return;
                let ids = [];
                this.select_table.forEach(v => {
                    ids.push(v.user_id)
                });
                if (ids.length === 0) {
                    this.$message.warning('请选择成员')
                } else {
                    return;
                    let params = {
                        user_ids: ids
                    };
                    this.httpPost('', params).then(res => {
                        this.$message.success('删除成功！');
                        if (this.tableData.length === ids.length) {
                            let page = this.currentPage === 1 ? 1 : this.currentPage - 1;
                            this.getTableData(page)
                        } else {
                            this.getTableData(this.currentPage)
                        }
                    })
                }
            },
            delRow(row) {
                this.$confirm(`确定删除岗位 ${row.job} 么？`).then(() => {
                    let params = {
                        department_id: row.department_id,
                        job: row.job
                    };
                    this.httpDel(`/user/rep_job`, {params}).then(res => {
                        this.$message.success('删除成功！');
                        if (this.tableData.length === 1) {
                            let page = this.currentPage === 1 ? 1 : this.currentPage - 1;
                            this.getTableData(page)
                        } else {
                            this.getTableData(this.currentPage)
                        }
                    }).catch(() => {
                    })
                })
            },
            delRowUser(row) {
                this.$confirm(`确定删除员工 ${row.name} 么？`).then(() => {
                    this.httpDel(`/user/rep/${row.user_id}`).then(res => {
                        this.$message.success('删除成功！');
                        if (this.tableData.length === 1) {
                            let page = this.currentPage === 1 ? 1 : this.currentPage - 1;
                            this.getTableData(page)
                        } else {
                            this.getTableData(this.currentPage)
                        }

                    }).catch(err => {
                        if (err.code === 1002) {
                            this.$message.warning('该用户有关联患者，无法删除')
                        }
                    })
                })
            },
            leaveOffice(row) {
                // this.$message.warning('正在开发中');
                this.$confirm(`确定员工 ${row.name} 已离职么？`).then(() => {
                    let params = {
                        user_id: row.user_id
                    };
                    this.httpPost(`/user/rep/leave_office`, params).then(res => {
                        this.$message.success('离职成功！');
                        // if (this.tableData.length === 1) {
                        //     let page = this.currentPage === 1 ? 1 : this.currentPage - 1;
                        //     this.getTableData(page)
                        // } else {
                        this.getTableData(this.currentPage)
                        // }
                    })
                })
            },

            editRow(row, type) {
                // this.$message.warning('正在开发中');
                let params = {
                    row: row,
                    type: type
                };
                this.setStaffData(params);
                this.$emit('changeTopTab', 'addView');
            },
            com_add() {
                let params = {
                    row: null,
                    type: 'add'
                };
                this.setStaffData(params);
                this.$emit('changeTopTab', 'addView');
            },

            getTableHeight() {
                this.$nextTick(() => {
                    let height = document.getElementsByClassName('right_box')[0].offsetHeight;
                    let search_height = document.getElementsByClassName('header')[0].offsetHeight;
                    let search_height2 = document.getElementsByClassName('top_btn_box')[0].offsetHeight;

                    this.tableHeight = height - search_height - search_height2 + 'px';
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    $view_background: rgb(246, 247, 248);
    $btn_border: rgb(246, 247, 248);

    .context {
        width: 100%;
        height: 100%;
        box-sizing: border-box;

        .header {
            display: flex;
            line-height: 40px;

            .title {
                font-size: 1.25rem;
                font-weight: 600;
                cursor: pointer;
            }

            .btn_left {
                margin: 0 20px;
            }

            .btn_box {
                flex: 1;
                text-align: right;
            }
        }

        .top_btn_box {
            width: 100%;
            background: #DFE9F3;
            line-height: 40px;
            padding: 0 10px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;

            .page_box {
                display: flex;
                padding-right: 15px;

                .page_icon {
                    width: 20px;
                    text-align: center;
                    color: #909399;
                    cursor: pointer;

                    &:hover {
                        i {
                            font-weight: 600;
                        }
                    }
                }

                .page_text {
                    width: 60px;
                    text-align: center;
                    color: #303133;
                }
            }
        }

        .table_box {
            width: 100%;
            .is_level_job {
                color: #F56C6C;
            }
        }
    }

    .tree_box_pop {
        .btn_box {
            line-height: 30px;
            font-size: 1rem;

            .btn {
                cursor: pointer;
            }
        }
    }

    .msg__ {
        line-height: 40px;
        padding: 0 40px;
        font-size: 16px;
        .msg_c {
            font-size: 16px;
        }
    }
</style>
<style lang="scss">
    .staff_table_box {
        .el-table .el-table__cell {
            padding: 0;
        }

        .el-table th.el-table__cell {
            padding: 12px 0;
            background: #f5f7fa;
        }
    }
</style>